// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NfpU","title":"styles_title__25-KX"};